import { defineRecipe } from '@chakra-ui/react/styled-system';

const spinnerRecipe = defineRecipe({
  className: 'spinner',
  base: {
    '--spinner-color': 'currentColor',
    '--spinner-track-color': 'transparent',
    display: 'inline-block',
    borderColor: 'var(--spinner-color)',
    borderStyle: 'solid',
    borderWidth: '2',
    borderRadius: '100%',
    width: 'var(--spinner-size)',
    height: 'var(--spinner-size)',
    animation: 'spin',
    animationDuration: '500ms',
    borderBottomColor: 'var(--spinner-track-color)',
    borderInlineStartColor: 'var(--spinner-track-color)',
  },
  variants: {
    size: {
      md: { '--spinner-size': 'sizes.12' },
      lg: { '--spinner-size': 'sizes.20' },
    },
    variant: {
      primary: {
        '--spinner-color': 'colors.purple.10',
      },
      purple: {
        '--spinner-color': 'colors.purple.40',
      },
      white: {
        '--spinner-color': 'colors.neutral.100',
      },
      'on-disabled': {
        '--spinner-color': 'colors.neutral.70',
      },
    },
  },
  defaultVariants: {
    size: 'lg',
  },
});

export default spinnerRecipe;
